import { register } from 'register-service-worker'

register(process.env.SERVICE_WORKER_FILE, {
  ready (registration) {
    console.log('✅ Service worker is active.')
  },

  registered (registration) {
    console.log('📝 Service worker has been registered.')

    // Filet de sécurité : vérification horaire (le backend prévient par WebSocket dès un déploiement,
    // et le navigateur vérifie à chaque ouverture)
    setInterval(() => {
      registration.update().catch(() => {})
    }, 1000 * 60 * 60)
  },

  cached (registration) {
    console.log('💾 Content has been cached for offline use.')
  },

  updatefound (registration) {
    console.log('🔄 New content is downloading.')
  },

  updated (registration) {
    // La nouvelle version s'active et recharge la page d'elle-même (src-pwa/custom-service-worker.js) ;
    // la notification après rechargement est gérée par src/boot/appUpdate.js
    console.log('🆕 New content is available!')
  },

  offline () {
    console.log('📡 No internet connection. Running in offline mode.')
  },

  error (err) {
    console.error('❌ Service worker registration error:', err)
  }
})